// extracted by mini-css-extract-plugin
export default {"accordion":"outputs-accordion_accordion__zeMXo","skeleton":"outputs-accordion_skeleton__7XVv9"};